import {connect, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import Loading from "../../../common/Loading";
import {
    getDhPowerballOdds,
    saveMinigameHoleOddList,
} from "../../../../api/api";
import {exportUseYn} from "../../../common/Global";

const DhPowerBallOddList = (props) => {
    const {user} = useSelector((props) => props.account);
    const [loading, setLoading] = useState(false)
    const [searchForm, setSearchForm] = useState({
        minigameId: "dhpowerball"
    })
    const [dataList, setDataList] = useState([])

    useEffect(() => {
        search()
    }, [])

    const handleDate = (date) => {
        setSearchForm({
            ...searchForm,
            gameDt: date
        })
    }

    const handleWhere = (e) => {
        const {name, value} = e.target;
        setSearchForm({
            ...searchForm,
            [name]: value
        })
    }

    const search = () => {
        setLoading(true)
        getDhPowerballOdds(user.companyCode, searchForm.minigameId).then(result => {
            const {data, status, statusText} = result
            if (status === 200) {
                setDataList(data)
            }
        })
            .catch(ex => {})
            .finally(() => setLoading(false))
    }

    const handleOddsChange = (gameType, hole, newValue) => {
        setDataList(prevList => 
            prevList.map(item => 
                item.holeType === gameType
                    ? {
                        ...item,
                        holeList: item.holeList.map(h => 
                            h.hole === hole
                                ? {...h, odds: parseFloat(newValue) || 0}
                                : h
                        )
                    }
                    : item
            )
        );
    };

    const save = () => {
        if (!window.confirm("저장하시겠어요?")) return;

        setLoading(true)
        // dataList의 미니게임 베팅카트별 배당율(holeList)을 하나의 array 로 취합
        const params = []
        
        dataList.forEach(item => {
            if (item.holeList && Array.isArray(item.holeList)) {
                item.holeList.forEach(hole => {
                    params.push({
                        ...hole,
                        companyCode: user.companyCode,
                        gameCode: item.gameCode
                    });
                });
            }
        });

        saveMinigameHoleOddList(params).then(result => {
            const {data, status, statusText} = result
            if (status === 200) {
                search()
            }
        })
            .catch(ex => {})
            .finally(() => setLoading(false))
    }

    return (
        <div className="flex flex-col">
            {loading ? <Loading /> : null}
            <div className={"flex flex-row gap-2 mb-2 items-center"}>
                <span className={"font-bold text-zinc-800"}>⌘</span>
                <span className={"text-sm text-zinc-500"}>미니게임 관리</span>
                <span className={"text-sm text-blue-500"}>{"-"}</span>
                <span className={"text-sm text-zinc-500"}>동행파워볼</span>
                <span className={"text-sm text-blue-500"}>{"-"}</span>
                <span className={"text-sm font-bold"}>배당 설정</span>
            </div>
            <div className="flex flex-row p-2 gap-1 items-center justify-end bg-white mt-1">
                <button className={"rounded bg-zinc-800 text-white px-3 py-1 text-sm"} onClick={save}>저장</button>
            </div>
            <div className={"mt-2"}>
                <div className="grid grid-cols-12 gap-2 bg-gray-100 p-2">
                    <div className="col-span-3 font-bold">베팅종류</div>
                    <div className="col-span-3 font-bold">사용여부</div>
                    <div className="col-span-6 font-bold">배당률</div>
                </div>
                {dataList.map((item, index) => (
                    <div key={index} className="grid grid-cols-12 gap-2">
                        <div className="col-span-3 p-2 text-sm font-medium bg-gray-100">{item.holeTypeNm}</div>
                        <div className="col-span-3 p-2 text-sm font-medium">{exportUseYn(item.useYn)}</div>
                        <div className="col-span-6 p-2">
                            <div className="flex flex-col gap-2">
                                {item.holeList.map((hole, holeIndex) => (
                                    <div key={holeIndex} className="flex items-center gap-2">
                                        <span className="text-sm w-32">{hole.holeNm}</span>
                                        <input
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            className="w-20 text-center border rounded px-2 py-1 text-sm"
                                            value={hole.odds}
                                            onChange={(e) => handleOddsChange(item.holeType, hole.hole, e.target.value)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    const {account, store} = state;
    return {
        account, store
    }
}

export default connect(mapStateToProps, null)(DhPowerBallOddList);